export default "__VITE_ASSET__CLDrFUX1__"